import { EStatus } from 'shared/types/form';
import { TApplicationState } from 'shared/types/redux';

export const selectAddressValidateStatus = (state: TApplicationState): EStatus => {
  return state.address.status;
};
